'use strict';
/* global MobileEsp Fingerprint2 Stat $ */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */

import Fingerprint2 from "fingerprintjs2";

(function() {

    var IMAGE_PATH = '/assets/img/mob_app_01.png';
    var BACKGROUND_PATH = '/assets/img/mob_app_bg.jpg';
    // var CLOSE_PATH = '/app/close_e70601662c03f39463aea881480b42d4.png';
    var COOKIE_USER = 'app-banner-user';
    var COOKIE_SYSTEM = 'inside-route-user';

    var ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.faceit.ryaba';
    // eslint-disable-next-line max-len
    var IOS_LINK = 'https://itunes.apple.com/ua/app/%D1%81%D1%96%D0%BC%D0%B5%D0%B9%D0%BD%D0%B8%D0%B9-%D0%B3%D0%B0%D0%BC%D0%B0%D0%BD%D0%B5%D1%86%D1%8C/id1439427338?mt=8';

    var link, image, background, close, fp;


    function get_fp(callback) {
        if (window.requestIdleCallback) {
            requestIdleCallback(function () {
                Fingerprint2.get(function (components) {
                    // eslint-disable-next-line max-nested-callbacks
                    var values = components.map(function (component) {
                        return component.value;
                    });
                    fp = Fingerprint2.x64hash128(values.join(''), 31);
                    if (callback) {
                        callback();
                    }
                });
            });
        } else {
            setTimeout(function () {
                Fingerprint2.get(function (components) {
                    // eslint-disable-next-line max-nested-callbacks
                    var values = components.map(function (component) {
                        return component.value;
                    });
                    fp = Fingerprint2.x64hash128(values.join(''), 31);
                    if (callback) {
                        callback();
                    }
                });
            }, 500);
        }
    }


    function getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        ));
        // eslint-disable-next-line no-undefined
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }


    function setCookie(name, value, options) {
        var options = options || {};

        var expires = options.expires;

        if (typeof expires == "number" && expires) {
          var d = new Date();
          d.setTime(d.getTime() + expires * 1000);
          expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
          options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
          updatedCookie += "; " + propName;
          var propValue = options[propName];
          if (propValue !== true) {
            updatedCookie += "=" + propValue;
          }
        }

        document.cookie = updatedCookie;
    }

    function deleteCookie(name) {
        setCookie(name, '', {
          expires: -1,
        });
    }


    function add_image(blob, type) {
        var imageURL = window.URL.createObjectURL(blob);

        switch(type) {
            case 'image':
                image.src = imageURL;
                break;
            case 'background':
                background.style.backgroundImage = 'url(' + imageURL + ')';
                break;
            case 'close':
                close.src = imageURL;
                break;
            default:
                break;
        }
    }


    function show_banner() {

        if(window.location.hash && window.location.hash.indexOf('shops') != -1) {
            return;
        }

        Stat.push('show', fp);

        background.addEventListener('transitionend', function() {
            background.classList.add('bn-show-close');
        });
        background.classList.add('bn-show');
    }


    function hide_banner() {
        // setCookie(COOKIE, 'lock', {expires: 3600 * 24});
        Stat.push('hide', fp);
        setCookie(COOKIE_USER, 'lock_banner');
        background.style.display = 'none';
    }


    function link_banner() {
        // setCookie(COOKIE, 'lock', {expires: 3600 * 24 * 30});
        Stat.push('click', fp);
        setCookie(COOKIE_USER, 'lock_banner');
        background.style.display = 'none';
    }


    // https://github.com/mdn/js-examples/blob/master/promises-test/index.html
    function imgLoad (url, type) {
        // Create new promise with the Promise() constructor;
        // This has as its argument a function
        // with two parameters, resolve and reject

        return new Promise(function(resolve, reject) {
            // Standard XHR to load an image
            var request = new XMLHttpRequest();
            request.open('GET', url);
            request.responseType = 'blob';

            // When the request loads, check whether it was successful
            request.onload = function() {
                if (request.status === 200) {
                    // If successful, resolve the promise by passing back the request response
                    add_image(request.response, type);
                    resolve();
                } else {
                    // If it fails, reject the promise with a error message
                    reject(Error('Image didn\'t load successfully; error code:'
                            + request.statusText));
                }
            };

            request.onerror = function() {
                // Also deal with the case when the entire request fails to begin with
                // This is probably a network error, so reject the promise
                // with an appropriate message
                reject(Error('There was a network error.'));
            };

            // Send the request
            request.send();
        });
    }


    // MobileEsp.InitDeviceScan();


    function load_images() {
        Promise.all([
            imgLoad(IMAGE_PATH, 'image'),
            imgLoad(BACKGROUND_PATH, 'background'),
            // imgLoad(CLOSE_PATH, 'close'),
        ])
        .then(
            show_banner,
            function(error) {
                console.error(error);
        });

    }

    function init() {

        var iOS = MobileEsp.DetectIos();
        var Android = MobileEsp.DetectAndroid();

        if (!iOS && !Android) {
            return;
        }

        // deleteCookie(COOKIE_USER);
        // deleteCookie(COOKIE_SYSTEM);

        $('a').click(function(){
            if(this.target === '_blank') {
                return;
            }
            setCookie(COOKIE_SYSTEM, 'system', {expires: 60});
        });

        if (getCookie(COOKIE_SYSTEM) && getCookie(COOKIE_USER)) {
            deleteCookie(COOKIE_SYSTEM);
            return;

        } else if (getCookie(COOKIE_SYSTEM)) {
            deleteCookie(COOKIE_SYSTEM);

        } else if (!getCookie(COOKIE_SYSTEM)) {
            deleteCookie(COOKIE_USER);
        }

        image = document.querySelector('.bn-image');
        link = document.querySelector('.bn-link');
        background = document.querySelector('.bn-wrapper');
        close = document.querySelector('.bn-close');

        if (!image || !link || !background || !close) {
            return;
        }

        if (iOS) {
            link.href = IOS_LINK;
        } else {
            link.href = ANDROID_LINK;
        }

        close.addEventListener('click', hide_banner);
        link.addEventListener('click', link_banner);

        // load_images();
        get_fp(load_images);
    }

    document.addEventListener('DOMContentLoaded', init);
}());
